import { combineReducers } from "redux";
import authReducer from "../components/auth/store/authReducer";
import accountReducer from "../components/account/store/accountReducer";

import workspaceReducer from "../components/shared/layout/store/workspaceReducer";
import teamReducer from "../components/team/store/teamReducer";
import workspaceUsersReducer from "../components/workspace/users/store/workspaceUsersReducer";
import promptReducer from "../components/prompt/store/promptReducer";
import apiKeyReducer from "../components/api-keys/store/apiKeyReducer";
import formReducer from "../components/form/store/formReducer";
import endpointReducer from "../components/endpoint/store/endpointReducer";
import flowReducer from "../components/flows/store/flowReducer";
import sharedFormReducer from "../components/form/sharing/store/sharedFormReducer";

import hubReducer from "../components/hub/store/hubReducer";
import chatbotReducer from "../components/chatbot/store/chatbotReducer";
import chatbotWidgetReducer from "../widgets/chatbot/content/store/chatbotWidgetReducer";
import mcpServerReducer from "../components/mcp-platform/store/mcpServerReducer";
import vendorKeyReducer from "../components/workspace/vendor-keys/store/vendorKeyReducer";
import chatReducer from "../components/workspace/chats/store/chatReducer";
import newPromptsReducer from "../components/workspace/prompts/store/promptReducer";
import toolPluginReducer from "../components/workspace/tools/store/toolPluginReducer";
import kbaseReducer from "../components/workspace/knowledge/store/kbaseReducer";
import assistantReducer from "../components/workspace/assistants/store/assistantReducer";
import gatewayReducer from "../components/workspace/gateways/store/gatewayReducer";
import builderReducer from "../components/builder/store/builderReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  account: accountReducer,
  team: teamReducer,
  workspace: workspaceReducer,
  workspaceUsers: workspaceUsersReducer,

  prompts: promptReducer,
  apiKeys: apiKeyReducer,
  forms: formReducer,
  sharedForm: sharedFormReducer,
  endpoints: endpointReducer,
  flows: flowReducer,

  hub: hubReducer,
  chatbot: chatbotReducer,
  chatbotWidget: chatbotWidgetReducer,
  mcpServer: mcpServerReducer,
  vendorKeys: vendorKeyReducer,
  chats: chatReducer,
  newPrompts: newPromptsReducer,
  toolPlugins: toolPluginReducer,
  kbase: kbaseReducer,
  assistants: assistantReducer,
  gateways: gatewayReducer,
  builder: builderReducer,
});

export default rootReducer;
